import React from 'react';
import {
  DIALOG_TYPES,
  useGlobalDialogContext,
} from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';
import { CustomRejectionDialog } from './index';
import { DocumentRejectionReasonEnum } from 'common/document/enums/document-rejection-reason.enum';

export const CustomRejectionGlobalDialog = ({
  document,
  candidateFullName,
  manager,
  companyName,
  link,
  request,
}: any) => {
  const { hideDialog, showDialog } = useGlobalDialogContext();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handleSetCustomRejection = (rejectionDetails: string) => {
    if (rejectionDetails) {
      showDialog(DIALOG_TYPES.CONFIRM_REJECTION_GLOBAL_DIALOG, {
        reason: {
          rejectionReason: DocumentRejectionReasonEnum.OTHER,
          rejectionDetails,
        },
        document: document,
        candidateFullName,
        manager,
        companyName,
        link,
        request,
      });
    }
  };

  return (
    <CustomRejectionDialog
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      onSetCustomRejection={handleSetCustomRejection}
    />
  );
};
